export const OrderPrintBillingDocumentWarningDialogMessage = {
    modalTitle: 'Unable to Print',
    modalContent:
        'Invoices cannot be generated until EWA finalizes pricing. Receipts cannot be printed until final payment is recorded.',
} as const;
